import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extrato-compra',
  templateUrl: './extrato-compra.component.html'
})
export class ExtratoCompraComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
